import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { OutdatedAppWarnModal } from './OutdatedAppWarnModal';
import ModalBox from 'components/ModalBox';
import syncManager from '../../../utils/syncManager';
import { isEnabledCookie, getCookie, setCookie } from '../../../utils/cookie';
import { OUTDATED_APP_COOKIE_NAME, OUTDATED_APP_REFRESH_TIME } from './const';
import { isNullOrUndefined } from '../../../predicates/type';

const OutdatedApp: FC<PropsWithChildren> = ({ children }) => {
	const [isWarnModalOpen, setIsWarnModalOpen] = useState(false);
	const [allowCloseModal, setAllowCloseModal] = useState(false);

	useEffect(() => {
		syncManager.on('OUTDATED_APP', 'SHOW_MODAL', () => {
			if (!isEnabledCookie()) {
				return;
			}

			setIsWarnModalOpen(true);

			const refreshCookie = getCookie(OUTDATED_APP_COOKIE_NAME);

			if (!isNullOrUndefined(refreshCookie)) {
				setAllowCloseModal(true);

				return;
			}

			setTimeout(() => {
				setCookie(OUTDATED_APP_COOKIE_NAME, 'true', {
					hours: 1,
				});
				window.location.reload();
			}, OUTDATED_APP_REFRESH_TIME);
		});
	}, []);

	return (
		<>
			{children}
			<ModalBox
				size='small'
				open={isWarnModalOpen}
				hasFullScreen={false}
				onClose={() => {
					setIsWarnModalOpen(false);
				}}
				render={(renderData) => (
					<OutdatedAppWarnModal
						allowCloseModal={allowCloseModal}
						modalRenderProps={renderData}
					/>
				)}
			/>
		</>
	);
};

export { OutdatedApp };
